/**
 *
 * @param t
 * @returns


  COST_PROJECT_ACCOUNT: "cost1050",
  COST_PROJECT_ACCOUNT_CHANGE: "cost1060",

 */
export const getCostToPathName = (t = {}) => {
    const businessCode = t.businessCode || t.busCode || '';
    const base = '/cost';
    if (businessCode == 'cost2030') {
        return base + `/cp/price/approve?id=${t.businessKey}`;
    }
    // 编制
    if (businessCode == 'cost2010') {
        return base + `/cp/target/approve?id=${t.businessKey}`;
    }
    // 编制变更
    if (businessCode == 'cost2020') {
        return (base +
            `/cp/target-change/approve?id=${t.businessKey}&busId=${t.businessKey}`);
    }
    // 工序
    if (businessCode == 'cost1070') {
        return base + `/bq/proc/standard/approve?id=${t.businessKey}`;
    }
    // 工序变更
    if (businessCode == 'cost1080') {
        return base + `/bq/proc/standard-change/approve?id=${t.businessKey}`;
    }
    // 施工图复核
    if (businessCode == 'cost1030') {
        return base + `/bq/draw/review/approve?id=${t.businessKey}`;
    }
    // 施工图复核变更
    if (businessCode == 'cost1040') {
        return base + `/bq/draw/review-change/approve?id=${t.businessKey}`;
    }
    // 中标清单
    if (businessCode == 'cost1010') {
        return base + `/bq/winning/bid/approve?id=${t.businessKey}`;
    }
    // 中标清单变更
    if (businessCode == 'cost1020') {
        return base + `/bq/winning/bid-change/approve?id=${t.businessKey}`;
    }
    // 项目台账
    if (businessCode == 'cost1050') {
        return base + `/bq/project/account/approve?id=${t.businessKey}`;
    }
    // 项目台账变更
    if (businessCode == 'cost1060') {
        return (base +
            `/bq/project/account-change/approve?id=${t.businessKey}&basicId=${t.businessKey}`);
    }
};
export const costToPathNameMap = {
    cost1010: (t) => getCostToPathName(t),
    cost1020: (t) => getCostToPathName(t),
    cost1030: (t) => getCostToPathName(t),
    cost1040: (t) => getCostToPathName(t),
    cost1050: (t) => getCostToPathName(t),
    cost1060: (t) => getCostToPathName(t),
    cost1070: (t) => getCostToPathName(t),
    cost1080: (t) => getCostToPathName(t),
    cost2010: (t) => getCostToPathName(t),
    cost2020: (t) => getCostToPathName(t),
    cost2030: (t) => getCostToPathName(t),
};
